import { createContext } from 'react'

// Warn when Title is used without a TitleProvider
let didWarn = false

const defaultHandler = () => {
	if (didWarn) {
		return
	}
	didWarn = true
	console.warn('@subaio/components Title requires a TitleProvider to capture changes')
}

type Context = {
	onTitleUpdate: (title: string | null) => void
	title: string | null
}

export const context = createContext<Context>({ onTitleUpdate: defaultHandler, title: '' })
